import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const ProjectImage = ({ src }) => (
  <div className={styles.wrapper}>
    <div className={styles.box}>
      <img className={styles.fit} alt="Peter Miles Studio" src={src} />
    </div>
  </div>
);

ProjectImage.propTypes = {
  src: PropTypes.string.isRequired,
};

export default ProjectImage;



// WEBPACK FOOTER //
// ./src/components/ProjectImage/index.jsx